import React from 'react';
import classNames from '../helpers/classNames.js';
import Checkbox from './Checkbox.js';
import Label from './Label.js';
import getRandomizedElementId from '../helpers/getRandomizedElementId.js';
const CheckboxField = ({
  id = null,
  name,
  label,
  onChange,
  withBottomGap = false,
  defaultChecked,
  checked,
  rawInputProps = {}
}) => {
  const safeId = getRandomizedElementId({
    id,
    name
  });
  const className = classNames('ebds-checkbox-field', {
    '--with-bottom-gap': withBottomGap
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Checkbox, {
    id: safeId,
    name: name,
    onChange: onChange,
    defaultChecked: defaultChecked,
    checked: checked
    /* eslint-disable-next-line react/jsx-props-no-spreading */,
    rawInputProps: rawInputProps
  }), /*#__PURE__*/React.createElement(Label, {
    forInput: safeId,
    text: label
  }));
};
export default CheckboxField;